import {
	Circle,
	IconCalendarRegular,
	IconLightningRegular,
	IconRocketRegular,
	IconStarRegular,
	IconTrendDownRegular,
	skinVars,
} from "@telefonica/mistica";
import React from "react";
import { strings } from "../../localization";

interface Slide {
	title: string;
	description: string;
	icon: React.ReactNode;
}
const { texts } = strings.components.AnticipationAdvantages;

export const slides: Slide[] = [
	{
		title: texts[0].titleInfo,
		description: texts[0].desciptionInfo,
		icon: (
			<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
				<IconCalendarRegular color={skinVars.colors.brand} size={24} />
			</Circle>
		),
	},
	{
		title: texts[1].titleInfo,
		description: texts[1].desciptionInfo,
		icon: (
			<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
				<IconStarRegular color={skinVars.colors.brand} size={24} />
			</Circle>
		),
	},
	{
		title: texts[2].titleInfo,
		description: texts[2].desciptionInfo,
		icon: (
			<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
				<IconTrendDownRegular color={skinVars.colors.brand} size={24} />
			</Circle>
		),
	},
	{
		title: texts[3].titleInfo,
		description: texts[3].desciptionInfo,
		icon: (
			<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
				<IconRocketRegular color={skinVars.colors.brand} size={24} />
			</Circle>
		),
	},
	{
		title: texts[4].titleInfo,
		description: texts[4].desciptionInfo,
		icon: (
			<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
				<IconLightningRegular color={skinVars.colors.brand} size={24} />
			</Circle>
		),
	},
];
